import React, { useEffect } from "react";
import UserDetailsHeader from "../components/UserDetailsHeader";
import UserDetailsSidebar from "../components/UserDetailsSidebar";
import { useUserData } from "../hooks/useUserData";
import PageHeader from "../../../../core/common/crmComponents/PageHeader";
import LoaderComponent from "../../../../core/common/crmComponents/LoaderComponent";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import queryClient from "../../../../config/queryClient";
import { setReloading } from "../../../../core/data/redux/moduleDataSlice";

const UserDetails = () => {
  const { id: userId } = useParams();
  const dispatch = useDispatch();
  const reloading = useSelector((state) => state.moduleData.reloading);

  const { userData, isLoading } = useUserData(userId);

  useEffect(() => {
    if (reloading) {
      queryClient.invalidateQueries(["user", userId]);
      dispatch(setReloading(false));
    }
  }, [reloading, dispatch]);

  return (
    <>
      {isLoading ? (
        <LoaderComponent />
      ) : (
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <PageHeader pageName="User Overview" moduleName="user" />
                {/* /Page Header */}
              </div>
            </div>
            <div className="row">
              <UserDetailsHeader userData={userData} />

              <UserDetailsSidebar userData={userData} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserDetails;
